export default __webpack_public_path__ + "static/media/capitalTrabajoCicloIcon.518a2cec.svg";